<template>
  <div class="zs-bottom-container" v-if="processDetail.process && processDetail.process.status == 'todo'">
    <div id="buttonContainer" class="button-container">
      <!-- 分发部门选择 -->
      <el-button
        v-if="showToDeptButton"
        type="primary"
        @click="chooseDept"
      >选择分发部门</el-button>
      <!-- <el-button
        v-if="processStatus && !processDetail.process.isEndpoint && processDetail.button.find(b => b.buttonKey == 'wf_pass')"
        type="primary"
        v-preventReClick
        @click="goNext"
      >通过</el-button> -->
      <el-button 
        type="primary"
        v-preventReClick
        v-if="!showToDeptButton && processStatus && processDetail.button.find(b => b.buttonKey == 'wf_pass')"
        @click="goNext"
      >通过</el-button>
      <el-button
        v-if="processStatus && processDetail.button.find(b => b.buttonKey == 'wf_transfer')"
        type="primary"
        v-preventReClick
        @click="toPerson"
        plain
      >转他人处理</el-button>
      <el-button
        type="danger"
        @click="rollBack"
        plain
        v-preventReClick
        v-if="processStatus && processDetail.button.find(b => b.buttonKey == 'wf_reject')"
      >退回</el-button>
      <el-button
        type="primary"
        v-if="goEdit"
        v-preventReClick
        @click="goEditPage"
      >
        编辑
      </el-button>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="nodeVisible"
      :modal-append-to-body="false"         
      title="选择回退节点">
      <RollBack
        :nodeList="nodeList"
        @rollBack="handleRollBack"
        @cancelDialog="handleCancelDialog"
      />
    </el-dialog>

    <el-dialog
      title="转他人处理"
      :visible.sync="dialogVisible"
      :destroy-on-close='true'
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
     >
      <template>
        <avue-form
          :option="changeFormConfig"
          ref="changePersonForm"
          v-model="changeForm"
          @submit="handleSubmit"
        >
        </avue-form>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="taskToAnother">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="分发部门"
      :visible.sync="dialogDeptVisible"
      :destroy-on-close='true'
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
     >
      <template>
        <avue-form
          :option="selectDeptFormConfig"
          ref="changeDeptForm"
          v-model="selectDeptForm"
        >
        </avue-form>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDeptVisible = false">取 消</el-button>
        <el-button type="primary" @click="taskToDept">提 交</el-button>
      </span>
    </el-dialog>    

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />    
  </div>
</template>
<script>
import { getAcceptDept } from "@/api/zs/zs"
import { getSsoToken, getNextTaskInfo } from "@/api/workFlow/workFlow";
import SelectPerson from "@/components/SelectPersonnel/person";
import RollBack from '@/views/plugin/workflow/components/wf-rollBack'
import WorkFlow from "@/mixins/workFlow";
import { mapGetters } from "vuex";
export default {
  name: 'zsBottomLine',
  mixins: [WorkFlow],
  data() {
    return {
      accpetDeptList: [],
      nodeList: [],
      nodeVisible: false,
      dialogVisible: false,
      showSelectPeople: false,
      selectPeopleList: [],
      selectPeopleData: [],
      changeFormConfig: {
        emptyBtn: false,
        submitBtn: false,
        disabled: false,
        column: [
          {
            label: '接收人员',
            prop: 'handlerName',
            click: this.selectPersonClick,
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择接收人员",
                trigger: "change",
              },
            ]            
          },{
            label: '备注信息',
            span: 24,
            prop: 'remark',
            type: 'textarea'
          }
        ]
      },
      dialogDeptVisible: false,
      selectDeptForm: {},
      selectDeptFormConfig: {
        emptyBtn: false,
        submitBtn: false,
        disabled: false,
        column: [
          {
            label: '接收部门',
            prop: 'zs_accept_dept',
            type: 'select',
            dicData: [],
            props: {
              label: "dictKey",
              value: "dictValue"
            },
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择接部门",
                trigger: "change",
              },
            ]            
          }
        ]
      }
    }
  },
  props: {
    goEdit: {
      type: Boolean,
      default: false
    },    
    processDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  components: {
    RollBack,
    SelectPerson
  },
  computed: {
    ...mapGetters(["workFlowState", "workFlowData", 'flowData']),
    showToDeptButton() {
      if(this.processDetail.process && this.processDetail.process.taskName == '产投部分发') {
        return true
      }else {
        return false
      }
    },
    allowEdit() {
      return this.workFlowState.isFirstFlowPermission
    },
    processStatus() {
      if(this.processDetail && this.processDetail.process) {
        return this.processDetail.process.status == 'todo' ? true: false
      } else {
        return false
      }
    },
    taskId() {
      if(this.processDetail && this.processDetail.process) {
       return this.processDetail.process.taskId
      }
    }    
  },
  mounted() {
    this.queryDeptDic()
  },
  methods: {
    handleCancelDialog() {
      this.nodeVisible = false
    },

    async handleRollBack(nodeId, comment) {
      // 回退
      await this.taskFlowBack(this.taskId, nodeId, comment)
      this.$emit('refreshData')
      this.handleCancelDialog()
    },
    
    // 回退
    async rollBack() {
      // 查询可回退节点
      this.nodeList = await this.queryBackStepList(this.taskId)
      this.nodeVisible = true
    },

    goEditPage() {
      this.$router.push({path:`/zsProject/addProject/`})
    },

    async queryDeptDic() {
      const self = this
      const res = await getAcceptDept()
      if(res.data.code == 200) {
        const dataObject = res.data.data
        const dataArray = Object.keys(JSON.parse(JSON.stringify(res.data.data)))
        dataArray.map(item => {
          self.accpetDeptList.push({
            dictKey: dataObject[item],
            dictValue: item
          })
        })
        const column = this.findObject(this.selectDeptFormConfig.column, "zs_accept_dept");
        column.dicData = this.accpetDeptList
      }
    },

    async goNext() {
      const self = this;
      const { process } = this.processDetail;
      const { isEndpoint } = process;
      const { flowData } = this.$store.state.user;
      const msg = isEndpoint ? '是否办结当前流程？' : '是否转交下一步？';
      this.$confirm(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: true,
        closeOnPressEscape: true,
        closeOnHashChange: true
      }).then(() => {
        self.$emit('flowNext');
      }).catch(err => {});
    },    

    chooseDept() {
      this.dialogDeptVisible = true
    },

    taskToDept() {
      const self = this
      this.$refs.changeDeptForm.validate((valid) => {
        if (valid) {
          const deptData = self.accpetDeptList.filter(item=> {return item.dictValue == self.selectDeptForm.zs_accept_dept})[0]
          self.$emit('selectDeptNext', deptData)
        }else {
          self.$message.warning('请选择接受部门后提交')
        }
      })
    },

    closeSelectDeptDialog() {
      self.selectDeptForm.zs_accept_dept = ''
      this.dialogDeptVisible = false
    },

    selectPeopleFlowNext() {
      let formComplete = true
      this.selectPeopleData.map(item => {
        if(item.manager == '') {
          formComplete = false
        }
      })
      if(formComplete) {
        this.$emit("flowNext", this.selectPeopleData)
      }else {
        this.$message.warning('请先选择人员再提交')
      }
    },    

    toPerson() {
      this.resetForm()
      this.checkUserList = []
      this.dialogVisible = true
    },    

    // 任务转他人处理
    taskToAnother() {
      let self = this
      // 校验changePersonForm是否填写完全
      this.$refs.changePersonForm.validate(async(valid) => {
        if (valid) {
          // 发送请求
          await self.taskFlowTransfer({
            assignee: self.changeForm.handlerId,
            taskId: self.processDetail.process.taskId,
            comment: self.changeForm.remark
          })
          this.dialogVisible = false
          self.$emit('refreshData')
        } else {
          self.$message({
            message: "请填写完整信息后确认提交",
            type: "warning"
          });
        }
      });
    },

    closeSelectDialog() {
      this.showSelectPeople = false
    },

    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },
    
    setPeople(val) {
      this.checkUserList = val;
      let people = val.map((item) => {
        return item.realName;
      });
      let ids = val.map((item) => {
        return item.id;
      });
      this.changeForm.handlerId = ids.join(',')
      this.changeForm.handlerName = people.join(',')
    },      
  }
}
</script>
<style lang="scss" scoped>
.zs-bottom-container{
  width: 100%;
  height: 70px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
  .bottom-content{
    display: flex;
    justify-content: flex-end;
    padding-bottom: 15px;
    padding-top: 15px;
    border-top: 1px solid #f1f1f1;
  }
  .button-container{
    width: 78%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;

  }
}
/deep/.el-dialog {
  border-radius: 8px;
}  
/deep/ .el-dialog__header {
  border-radius: 5px 5px 0px 0px !important;
  background-color: rgb(245, 245, 245) !important;
  color: #333 !important;
  border-bottom: 1px solid #e4e4e4e4 !important;
}
/deep/ .el-dialog__body {
  padding: 20px 20px 20px !important;
}
</style>